export const name = [(v) => !!v || "Digite seu nome."];

export const email = [
  (v) => !!v || "Digite seu e-mail.",
  (v) => /.+@.+\..+/.test(v) || "Digite um e-mail válido.",
];

export const tel = [
  (v) => !!v || "Digite seu telefone.",
  (v) => /^\([0-9]{2}\) [0-9]{4,5}-[0-9]{4}$/.test(v) || "Digite um telefone válido",
];

export const message = [
  (v) => !!v || "Digite sua mensagem.",
  (v) =>
    v?.length <= 300 || "Sua mensagem deve conter menos que 300 caracteres",
];
